export default {
  app: {
    title: 'Miaobi AI Admin',
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    moreMenus: 'More',
    back: 'Back',
    backHome: 'Home',
    returnHome: 'Back Home',
    actions: {
      search: 'Search',
      reset: 'Reset',
      add: 'Add',
      addDevice: 'Add Device',
      edit: 'Edit',
      delete: 'Delete',
      detail: 'Details',
      view: 'View',
    },
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      online: 'Online',
      offline: 'Offline',
      allocated: 'Allocated',
      unallocated: 'Unallocated',
    },
    time: {
      createTime: 'Created At',
      updateTime: 'Updated At',
      editTime: 'Edited At',
      startTime: 'Start Time',
      endTime: 'End Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      to: 'to',
    },
    form: {
      all: 'All',
      input: 'Please enter {field}',
      select: 'Please select {field}',
      selectFirst: 'Please select {field} first',
    },
  },
  language: {
    label: 'Language',
    zhCN: '中文',
    enUS: 'English',
  },
  modal: {
    systemPrompt: 'System Prompt',
    prompt: 'Prompt',
  },
  request: {
    relogin: {
      message: 'Your session has expired. You can stay on this page or sign in again.',
      confirm: 'Sign In Again',
      expired: 'Invalid or expired session. Please sign in again.',
    },
    network: {
      error: 'Unable to connect to the backend API',
      timeout: 'The API request timed out',
      status: 'API request failed with status {status}',
    },
    download: {
      loading: 'Downloading data, please wait',
      error: 'Failed to download the file. Please contact the administrator.',
    },
    errors: {
      401: 'Authentication failed. System resources cannot be accessed.',
      403: 'You do not have permission for this action.',
      404: 'The requested resource does not exist.',
      default: 'Unknown system error. Please contact the administrator.',
    },
  },
  login: {
    username: 'Account',
    password: 'Password',
    captcha: 'Verification Code',
    rememberMe: 'Remember Password',
    submit: 'Sign In',
    submitting: 'Signing In...',
    registerNow: 'Register Now',
    validation: {
      username: 'Please enter your account',
      password: 'Please enter your password',
      captcha: 'Please enter the verification code',
    },
  },
  register: {
    confirmPassword: 'Confirm Password',
    submit: 'Register',
    submitting: 'Registering...',
    existingAccount: 'Sign in with an existing account',
    success: 'Congratulations, your account {username} has been registered successfully.',
    validation: {
      passwordMismatch: 'The two passwords do not match',
      usernameLength: 'Account length must be between 2 and 20 characters',
      passwordLength: 'Password length must be between 5 and 20 characters',
      invalidChars: 'Invalid characters are not allowed: < > " \' \\ |',
      confirmPassword: 'Please enter your password again',
    },
  },
  welcome: {
    title: 'Miaobi AI Management Platform',
    subtitle: 'Create with less effort',
    smartCreation: 'Smart Creation',
    efficientManagement: 'Efficient Management',
    intelligentAnalysis: 'Intelligent Analysis',
  },
  errorPage: {
    401: {
      title: '401 Error!',
      headline: 'Access Denied',
      description: 'Sorry, you do not have permission to access this page. Please return to the home page.',
    },
    404: {
      title: '404 Error!',
      headline: 'Page Not Found',
      description: 'Sorry, the page you are looking for does not exist. Check the URL, refresh the page, or browse other sections of the app.',
    },
  },
  route: {
    aiChat: 'Magic Brush',
    imageCutDiagram: 'AI Background Removal',
    aiSchedule: 'Scheduling Center',
    home: 'Home',
    profile: 'Profile',
    assignRole: 'Assign Roles',
    assignUser: 'Assign Users',
    dictData: 'Dictionary Data',
    jobLog: 'Job Logs',
    genEdit: 'Edit Generation Config',
    institutionInfo: 'Institution Info',
  },
  layout: {
    logout: 'Sign Out',
    logoutConfirm: 'Are you sure you want to sign out?',
    settings: {
      themeStyle: 'Theme Style',
      themeColor: 'Theme Color',
      layout: 'Layout Settings',
      topNav: 'Enable TopNav',
      tagsView: 'Enable Tags View',
      fixedHeader: 'Fixed Header',
      sidebarLogo: 'Show Logo',
      dynamicTitle: 'Dynamic Title',
      save: 'Save',
      reset: 'Reset',
      saving: 'Saving settings locally, please wait...',
      resetting: 'Clearing settings cache and refreshing, please wait...',
    },
    tagsView: {
      refresh: 'Refresh',
      closeCurrent: 'Close Current',
      closeOthers: 'Close Others',
      closeLeft: 'Close Left',
      closeRight: 'Close Right',
      closeAll: 'Close All',
    },
  },
  equipment: {
    fields: {
      assignedOrg: 'Assigned Organization',
      brand: 'Brand',
      deviceAssetNo: 'Device Asset No.',
      deviceBrand: 'Device Brand',
      deviceImage: 'Image',
      deviceModel: 'Device Model',
      deviceName: 'Device Name',
      deviceSerial: 'Device Serial No.',
      deviceStatus: 'Device Status',
      dispatchStatus: 'Assignment Status',
      ipAddress: 'IP Address',
      model: 'Model',
      operation: 'Actions',
      remark: 'Remark',
      serialNo: 'Serial No.',
    },
    list: {
      sequence: 'No.',
      classroomSeat: 'Classroom / Seat',
      dialogAdd: 'Add Device',
      dialogEdit: 'Edit Device',
      dialogView: 'View Device',
      deleteConfirm: 'Are you sure you want to delete "{name}"?',
      deleteWarning: 'This device cannot be recovered after deletion. Please proceed with caution.',
      deleteSuccess: 'Deleted successfully',
      updateSuccess: 'Updated successfully',
      createSuccess: 'Created successfully',
      remarkPlaceholder: 'Enter remarks, such as physical specs, configuration, or accessories.',
      validation: {
        deviceName: 'Device name is required',
        deviceNameLength: 'Length must be between 2 and 20 characters',
        deviceModel: 'Device model is required',
        deviceBrand: 'Device brand is required',
        deviceSerial: 'Device serial number is required',
        deviceStatus: 'Device status is required',
        dispatchStatus: 'Assignment status is required',
        assignedOrg: 'Assignment information is required',
        assetNo: 'Device asset number is required',
        image: 'Please upload a device image',
      },
    },
  },
  equipment3d: {
    fields: {
      accessCode: 'Access Code',
      brand: 'Brand',
      connectionStatus: 'Connection',
      deviceBrand: 'Device Brand',
      deviceIp: 'Device IP',
      deviceIpAddress: 'Device IP Address',
      deviceName: 'Device Name',
      deviceStatus: 'Device Status',
      deviceType: 'Device Type',
      ipAddress: 'IP Address',
      model: 'Model',
      operation: 'Actions',
      printSize: 'Print Size',
      printSizeWithUnit: 'Print Size (cm)',
      serialNo: 'Serial No.',
      spec1: 'Spec 1',
      spec2: 'Spec 2',
      maxHeight: 'Max Height',
    },
    actions: {
      addDevice: 'Add Device',
    },
    dialog: {
      addTitle: 'Add Device',
      editTitle: 'Edit Device',
      subtitle: 'Different 3D printer brands vary greatly in setup. Please contact the system brand specialist first.',
    },
    placeholder: {
      printerName: 'Brand name of the 3D printer',
      printerIp: 'LAN IP address of the 3D printer for device connection',
      accessCode: 'Access code of the 3D printer for API authentication',
      serialNo: 'Unique serial number of the 3D printer for device identification',
      numberCm: 'Please enter a number (cm)',
      maxHeight: 'Please enter the maximum height',
    },
    validation: {
      deviceType: 'Please select a device type',
      deviceName: 'Please enter a device name',
    },
    message: {
      deleteConfirm: 'Are you sure you want to delete device "{name}"? This action cannot be undone.',
      deleteSuccess: 'Deleted successfully',
      updateSuccess: 'Updated successfully',
      createSuccess: 'Created successfully',
    },
  },
}
